import { createContext, type PropsWithChildren, useMemo } from 'react';

export interface I18nContextType {
  resolvedLanguage: string;
  t: (key: string, options?: Record<string, unknown>) => string;
}

export const I18nContext = createContext<I18nContextType | null>(null);

export const I18nProvider = ({
  children,
  i18n,
}: PropsWithChildren<{ i18n: I18nContextType }>) => {
  const value = useMemo<I18nContextType>(() => {
    return {
      resolvedLanguage: i18n.resolvedLanguage,
      t: typeof i18n.t === 'function' ? i18n.t : (key) => key,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.resolvedLanguage]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};
